import React, {Component} from 'react';
import '../css/ProgramsPage.css';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {COLORS} from '../constants';
import {getLang} from '../selectors';
import ProgramSection from './ProgramSection';
import Crumbs from './Crumbs';
import {
  introToTech,
  webDev,
  language,
  spanishLanguage,
} from '../text';

import {ProgramsPage as pps} from '../strings';
import {Crumbs as cs} from '../strings';


class ProgramsPage extends Component {

  // componentWillReceiveProps(nextProps) {
  //   const {position} = nextProps;
  //   const {x, y} = position;
  //    const fixedClassName = 'fixed-with-header-visible';


  //   if (y !== this.props.y || x !== this.props.x) {
  //     if (y > 190) {
  //       console.log('greater than 200');
  //       this.program.classList.add(fixedClassName);
  //     }
  //     else {
  //       console.log('less than 200');
  //       this.program.classList.remove(fixedClassName);
  //     }
  //   }
  // }

  componentDidMount() {
    window.scrollTo(0,0);
  }

  makeCrumbs() {
    const {lang} = this.props;
    
    const crumbs = [
      {
        label: cs.home[lang],
        link: '/home',
      },
      {
        label: cs.programs[lang],
      },
    ]

    return crumbs;
  }

  render() {
    const {
      lang,
    } = this.props;

    const programs = [
      webDev,
      language,
      introToTech,
      spanishLanguage,
    ]

    return(
      <div style={s.container} className="programs-page fade-in">
        <div style={s.crumbsContainer}>
          <Crumbs crumbs={this.makeCrumbs()} />
        </div>
        <div style={s.header}>
          <h1 style={s.title}>
            {pps.title[lang]}
          </h1>
          <p style={s.subtitle}>
            {pps.subtitle[lang]}
          </p>
        </div>

        <div style={s.content}>
          <div>
            {programs.map((p, i) => (
              <ProgramSection
                key={i}
                content={p}
                lang={lang}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

const maxWidth = '800px';


const s = {
  container: {
    maxWidth,
    margin: 'auto',
    // padding: '0px 20px',
    // paddingTop: '20px',
    padding: '20px',
  },
  header: {
    //marginTop: '40px',
    marginBottom: '40px',
  },
  title: {
    fontSize: '200%',
    fontWeight: 'bold',
    marginBottom: '25px',
    color: 'white',
  },
  subtitle: {
    color: COLORS.gray200,
    fontSize: '90%',
    maxWidth: '400px',
    lineHeight: '1.7',
  },
  content: {

  },
  crumbsContainer: {
    margin: '10px 0px 60px',
  },
}

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}


let Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgramsPage)

Connected = withRouter(Connected);
//Connected = (Connected);
export default Connected;



// WEBPACK FOOTER //
// ./src/main/ProgramsPage.js